export function DifficultyBadge({ level }) {
  const styles = {
    easy: "bg-success/10 text-success border-success/30",
    medium: "bg-accent/30 text-primary border-accent",
    hard: "bg-destructive/10 text-destructive border-destructive/30",
  };
  return (
    <span data-testid={`difficulty-badge-${level}`}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border capitalize ${styles[level] || styles.medium}`}>
      {level}
    </span>
  );
}

export function SegmentedBar({ correct = 0, incorrect = 0, total = 0, height = "h-2.5" }) {
  const c = total ? (correct / total) * 100 : 0;
  const i = total ? (incorrect / total) * 100 : 0;
  return (
    <div className={`w-full ${height} rounded-full bg-muted overflow-hidden flex`} role="img"
      aria-label={`${correct} correct, ${incorrect} incorrect, ${total - correct - incorrect} unanswered of ${total}`}>
      <div className="bg-success transition-[width] duration-500" style={{ width: `${c}%` }} />
      <div className="bg-destructive transition-[width] duration-500" style={{ width: `${i}%` }} />
    </div>
  );
}

export function StatCard({ label, value, sub, testid }) {
  return (
    <div className="bg-card border border-border rounded-lg p-5 shadow-sm" data-testid={testid}>
      <p className="text-xs tracking-[0.15em] uppercase font-semibold text-muted-foreground">{label}</p>
      <p className="mt-2 font-display text-3xl font-bold text-foreground">{value}</p>
      {sub && <p className="mt-1 text-xs text-muted-foreground">{sub}</p>}
    </div>
  );
}

export function EmptyState({ title, body, children, testid }) {
  return (
    <div className="bg-card border border-dashed border-border rounded-lg p-10 text-center" data-testid={testid}>
      <h3 className="font-display font-semibold text-lg">{title}</h3>
      <p className="mt-2 text-sm text-muted-foreground max-w-md mx-auto">{body}</p>
      {children && <div className="mt-5">{children}</div>}
    </div>
  );
}

export function PageHeader({ title, sub, children }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
      <div>
        <h1 className="font-display text-2xl md:text-3xl font-bold tracking-tight" data-testid="page-title">{title}</h1>
        {sub && <p className="mt-1.5 text-sm text-muted-foreground">{sub}</p>}
      </div>
      {children}
    </div>
  );
}
